import { render, staticRenderFns } from "./CreateOnlineAccount.vue?vue&type=template&id=106583fe"
import script from "./CreateOnlineAccount.vue?vue&type=script&lang=js"
export * from "./CreateOnlineAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports